import { MembershipDetails } from "../components/details/MembershipDetails";
import { MembershipSection } from "../components/sections/MembershipSection";
import { HelpCenterSectionModel } from "../models/HelpCenterSectionModel";

export const HelpSections: HelpCenterSectionModel[] = [
    {
        id: 0,
        title: 'Membership & Loyalty',
        detail: <MembershipDetails />,
        section: <MembershipSection />
    },
    {
        id: 1,
        title: 'Community Guide',
        detail: <MembershipDetails />,
        section: <MembershipSection />
    },
    {
        id: 2,
        title: 'Hosting Experiences',
        detail: <MembershipDetails />,
        section: <MembershipSection />
    },
    {
        id: 3,
        title: 'Invitations',
        detail: <MembershipDetails />,
        section: <MembershipSection />
    },
    {
        id: 4,
        title: 'Booking',
        detail: <MembershipDetails />,
        section: <MembershipSection />
    },
    {
        id: 5,
        title: 'Payments & Taxes',
        detail: <MembershipDetails />,
        section: <MembershipSection />
    }
]